import { handleGlobalGetRequestQuery } from "@/lib/httpFunction/globalApiFunction";
import { QUERY_KEYS } from "@/services/KEYS/QUERY_KEYS";
import { CORE_URLS } from "@/services/URLS/CORE_URLS";
import { useQuery } from "@tanstack/react-query";

export interface AgentStep {
  id: number;
  label: string;
  path: string;
  icon: string;
}

export interface AgentMenuResponse {
  data: AgentStep[];
  message?: string;
  status?: string;
}

const useGetAgentMenu = () => {
  const getAllAgentMenu = useQuery<AgentMenuResponse>({
    queryKey: [QUERY_KEYS.AGENT_MENU],
    queryFn: () => handleGlobalGetRequestQuery({ url: CORE_URLS.AGENT_MENUS }),
  });

  return {
    services: { getAllAgentMenu },
  };
};

export default useGetAgentMenu;
